import {ServicesService} from '../../rest-service/services.service';
import {Injectable} from '@angular/core';
import {Server} from '../dto/Server';
import {HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Configuration} from '../../core/common/configuration';

@Injectable()
export class StoreServerManagerService {

  protected readonly BASE_URL: string = 'store_server';

  constructor(protected services: ServicesService,
              protected config: Configuration) {
  }

  getDefaultServer(): Observable<HttpResponse<Server>> {
    return this.services.get<Server>(
      this.BASE_URL + '/getDefaultServer',
      {},
      'Impossibile recuperare le informazioni per il file!'
    );
  }

  getServerAvailable(): Observable<HttpResponse<Server>> {
    return this.services.get<Server>(
      this.BASE_URL + '/getServerAvailable',
      {allFileSize: this.config.MAX_FILE_SIZE_MB * 1024 * 1024},
      'Impossibile recuperare le informazioni per il file!'
    );
  }

  getServerHost(serverId: number): Observable<HttpResponse<Server>> {
    return this.services.get<Server>(
      this.BASE_URL + '/getServerById',
      {serverId},
      'Impossibile recuperare le informazioni per il file!'
    );
  }

}
